import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CarouselHOC from "../CarouselHOC";

/*
* It is used to render LISTINGS CAROUSEL, Drupal Rets View Displays
* for Carousels (homepage sponsors, etc.), GUTENBERG MUI "SLIDER" widget
*/
// To override/merge styles in CarouselHOC:
const useStyles = makeStyles((theme) => ({
  rootCarousel: {
    "& .featured .slick-slide": {
      [theme.breakpoints.up("sm")]: {
        "& > div": {
          // height: 135,
        }
      },
      [theme.breakpoints.up("md")]: {
        "& > div": {
          height: '13.9vw',
        }
      },
    },
    "& .slick-slide": {
      "& > div": {
        height: 'auto',
      },
      "& >div>*:not(:last-child)": {
        [theme.breakpoints.up("sm")]: {
          paddingRight: 0,
        },
      },
      "& >div>div>*": {
        display: 'inline',
        [theme.breakpoints.down("sm")]: {},
      }
    },
    "& .slick-dots": {
      position: 'absolute',
      bottom: '1.5rem',
      left: '1.5rem',
      textAlign: 'left',
      "& li button:before": {
        fontSize: 24,
        color: 'white',
        opacity: 1,
      },
      "& li.slick-active button:before": {
        color: theme.palette.warning.main,
      },
      "& li:hover button:before": {
        color: theme.palette.warning.main,
      }
    },
  },
  slickPrev: {},
  slickSliderInner: {
    "&.featured": {
      [theme.breakpoints.up("sm")]: {
        width: '200%',
        marginLeft: '-50%',
        clear: 'both',
        transition: 'all .75s',

        "& $firstImage": {
          width: '25%',
          transition: 'all .75s',
        },
        "& $slickImages": {
          width: '50%',
          display: 'inline-block',
          transition: 'all .75s',
        },
        "& $galleryImage": {
          // height: 135,
          [theme.breakpoints.up("md")]: {
            // height: 200,
          },
        },
      },
    },
    "&.featured.active": {
      [theme.breakpoints.up("sm")]: {
        marginLeft: '0',
        "& $galleryImage": {
          paddingLeft: '0px',
          paddingRight: '0px',
        },
        '& :not(.thumb-nav)>$slickNext': {
          right: 'calc(50% + .25rem)',
        },
        '& :not(.thumb-nav)>$slickPrev': {
          left: '-50%',
        },
      },
    },
  },
  firstImage: {
    display: 'inline-block',
  },
  slickImages: {},
  featuredImage: {
    height: 'auto !important',
    [theme.breakpoints.up("md")]: {
      height: 'auto !important',
    },
  },
  galleryImage: {
    // height: 400,
  },
  thumbImage: {
    height: 100,
  },
  slickArrow: {
    backgroundColor: 'rgba(0,0,0,.8)',
    width: '30px',
    "& svg": {
      width: '2rem',
      height: '3rem',
      color: 'white',
    }
  },
  slickNext: {
    right: '0',
  }
}));

function CarouselMuiSlider(props) {
  let {
    customClass,
    slides,
    imgStyle,
    showLight,
    bannerSlider,
    showThumb,
    featured,
    slickSett,
    slickNavSett,
    children, margin,
    marginUnit, linkOut, gutter, captions
  } = props;

  if (!props.slides && !props.children) {
    return null;
  }

  showThumb = showThumb || {smUp: true};
  customClass = customClass || 'alignfull';
  const HOCstyles = useStyles();

  return (
      <div className={customClass}>
        <CarouselHOC bannerSlider={bannerSlider} classes={HOCstyles}
                     slides={slides} featured={featured}
                     slickSett={slickSett} showLight={showLight}
                     showThumb={showThumb} imgStyle={imgStyle}
                     margin={margin} marginUnit={marginUnit} linkOut={linkOut}
                     gutter={gutter}
                     slickNavSett={slickNavSett} captions={captions}>
          {children}
        </CarouselHOC>
      </div>
  );
}

export default CarouselMuiSlider;
